import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const Container = styled.div `
  display: inline-flex;
  align-items: center;
  gap: clamp(0.7rem, 0.8vw, 0.95rem);
  color: rgba(255, 255, 255, 0.72);
  font-family: 'Sora', sans-serif;
  font-size: clamp(0.62rem, 0.68vw, 0.78rem);
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
`;
const Logo = styled.img `
  display: block;
  height: clamp(1.25rem, 1.8vw, 2.2rem);
  width: auto;
`;
const PoweredByBrand = () => {
    const { t } = useTranslation();
    return (_jsxs(Container, Object.assign({ "aria-label": t('common.powered-by') }, { children: [_jsx("span", { children: t('common.powered-by') }), _jsx(Logo, { src: require('../../assets/images/cisco-spaces-logo.png'), alt: "Cisco Spaces" })] })));
};
export default PoweredByBrand;
